module.exports = __webpack_public_path__ + "heliasport-logo.svg?566081328b6671a721086ca7169527aa";